<div id="VIDEO_AD"></div>

<div id="videoPlayerContainer" data-shaka-player-container data-shaka-player-cast-receiver-id="930DEB06">
    <div id="PLAYER_BANNER"></div>
    <div class="vp-infos-container" [hidden]="!showControls">
        <div class="vp-top-bar">
            <i class="fa fa-arrow-left fa-2x ver-mid cursor-po-c" (click)="closeVideoPlayer(true)"></i>
            <img class="player-logo" src="assets/images/logo.png" />
        </div>
        <div class="vp-infos">
            <h1>{{data.title }}</h1>
            <h3>{{(data.currentEpisode ? "S" + data.currentEpisode.seasonNumber + "E" +
                data.currentEpisode.episodeNumber + " - " + data.currentEpisode.title : "")}}</h3>
            <div class="pb-4" [innerHTML]="data | setupSubInfo:lang"></div>
        </div>
    </div>
    <app-player class="video-container" [data]="data" (playerEvents)="playerEvents($event)"></app-player>
</div>